import { useRouteMatch } from 'react-router-dom';

import { FeatureFlagDeclarations } from '../../../feature-flags/feature-flag-declarations';
import { OrderOverviewRoute } from '../routing';
import { useFeatureFlag } from '../../../feature-flags/hooks/use-feature-flag';

/**
 * @returns {boolean} True if the order overview feature is enabled and the current route is an exact match
 * for the Order Overview page, otherwise false.
 */
export const useShowOrderOverview = () => {
  const hasOrderOverviewEnabled = useFeatureFlag(FeatureFlagDeclarations.enableOrderOverview);
  const match = useRouteMatch({ path: OrderOverviewRoute, exact: true });

  return !!(hasOrderOverviewEnabled && match?.isExact);
};
